import { MainConfig } from '#/service/config/config.types';
import { defaultConfig } from '#/service/config/defaultConfig';

let config = defaultConfig;

// config is only set during app startup (and stories/tests), otherwise it
// never changes. that's why we don't need a store for it.
export const initConfig = (newConfig: MainConfig) => {
  config = newConfig;
};

export const useConfig = () => config;
